import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import SportLivePeriod from './SportLivePeriod';

import styles from '../../../styles/partials/nhl-live-game-stats.module.scss';

const propTypes = {
    withLogo: PropTypes.bool,
    sportGame: AppPropTypes.sportGame,
    className: PropTypes.string,
};

const defaultProps = {
    withLogo: false,
    sportGame: null,
    className: null,
};

function NflLiveGameStats({ withLogo, sportGame, className }) {
    const { teamAway = null, teamHome = null } = sportGame || {};

    const teams = useMemo(
        () => (teamAway !== null && teamHome !== null ? [teamAway, teamHome] : []),
        [teamAway, teamHome],
    );

    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.teams}>
                {teams.map((currentTeam) => {
                    const { name, abbreviation, id, logo, score = 0 } = currentTeam || {};
                    const { url: logoUrl = null } = logo || {};

                    return (
                        <div className={styles.team} key={`team-${id}`}>
                            {logoUrl !== null && withLogo ? (
                                <img className={styles.logo} src={logoUrl} alt={name} />
                            ) : null}
                            <span className={styles.abbreviation}>{abbreviation}</span>
                            <span className={styles.goals}>{score}</span>
                        </div>
                    );
                })}
            </div>
            <SportLivePeriod className={styles.livePeriod} sportGame={sportGame} />
        </div>
    );
}

NflLiveGameStats.propTypes = propTypes;
NflLiveGameStats.defaultProps = defaultProps;

export default NflLiveGameStats;
